import types from './types';
import {errorInfoConfig} from '~/misc/error-info';
import modalTypes from '~/modules/modal/types';

const initMainSwitchData = {
  tool_window: {
    title: 'Rate Check Algorithm optimization',
    content: 'We have optimized the algorithm of Rate',
    tool_switch: 0,
  },
  email_switch: {
    chance: 0,
    switch: 0,
  },
  times_switch: {
    times: 0,
    switch: 0,
  },
};

const initData = {
  dot_sign_switch: 0,
  dot_validate_switch: 0,
  dot_window: {
    answer: 'Your DOT is incomplete or not verified, our verified brokers want to work with verified partners.',
    is_force_open: 0,
    open_rate: 0,
    question: 'Why your dot number needed?',
  },
};

const initialState = {
  loading: false,
  error: false,
  verifyDotMcData: {
    isVerified: false,
    loading: false,
    error: false,
    data: {},
  },
  mainSwitch: {
    loading: false,
    error: false,
    data: initMainSwitchData,
  },
  data: initData,
};

const processData = (data) => {
  const commData = {
    loading: false,
    data: data,
  };
  if (!data.mc_verified && !data.dot_verified) {
    return Object.assign({}, commData, {error: errorInfoConfig.dot.wrong, isVerified: false});
  }
  return Object.assign({}, commData, {error: 'success', isVerified: true});
};

const reducer = (state, action) => {
  // const aaa = action.payload.data;
  switch (action.type) {
    case types.GET_SWITCH_DATA: {
      if (action.pending) {
        return {
          ...state,
          mainSwitch: {
            loading: true,
            error: false,
            data: initMainSwitchData,
          },
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          mainSwitch: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        mainSwitch: {
          loading: false,
          error: action.payload.message || action.error,
          data: initMainSwitchData,
        },
      };
    }

    case types.DOT_MC_SWITCH: {
      if (action.pending) {
        return {
          ...state,
          data: initData,
          loading: true,
          error: false,
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          data: Object.assign({}, state.data, action.payload.data),
          loading: false,
          error: false,
        };
      }
      return {
        ...state,
        loading: false,
        data: initData,
        error: action.payload.message || action.error,
      };
    }

    case types.VERIFY_DOT_MC: {
      if (action.pending) {
        return {
          ...state,
          verifyDotMcData: {
            ...state.verifyDotMcData,
            loading: true,
            error: false,
            isVerified: true,
          },
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          verifyDotMcData: processData(action.payload.data),
        };
      }
      return {
        ...state,
        verifyDotMcData: {
          ...state.verifyDotMcData,
          loading: false,
          isVerified: false,
          error: action.payload.message || action.error,
        },
      };
    }

    case modalTypes.MODAL_URI_VERIFY_CLOSED: {
      return {
        ...state,
        verifyDotMcData: {
          isVerified: false,
          error: false,
        },
      };
    }

    default:
      return state;
  }
};
export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/dots/reducer.js